// This file contains the translations for the TaxFormWizard component.
const Es = 'es';
const En = 'en';

export const translations = {
    en: {
        RetunToChatButton: 'Return to chat',
        Close: 'Close',
        Help: 'Help',
        PhoneSupport: 'Phone Support',
        OffBusinessHours: 'Off Business Hours',
        SHOW_USER_NOT_FOUND:
            'Account could not be found. Try again or call (855) 708-4590 for help.',
        NavButton: {
            BackButton: 'Back',
            NextButton: 'Next',
            Confirm: 'Confirm',
            Close: 'Close',
            Cancel: 'Cancel',
            ExitButton: 'Exit',
            ProvideFeedbackButton: 'Provide Feedback',
            BeginButton: 'Begin',
            StartOverButton: 'Start over',
            SubmitButton: 'Submit',
        },
        WelcomePage: {
            Title: 'Get Your Tax Form',
            Body: "You're just a few easy steps away from downloading your tax form. Let's get started!",
            Body1: 'we can help you keep or cancel your plan. ',
            alt: 'Medi-Cal and Covered California Logos',
        },
        AuthenticationPage: {
            header: 'Verify Your Identity',
            subHeader: 'Enter your information below.',
            username: 'Username',
            userNamePlaceholder: 'Enter username',
            validationUsernameMessage: 'Please enter a valid username.',
            password: 'Password',
            forgotUsername: 'Forgot your username?',
            passwordPlaceholder: 'Enter password',
            validationPasswordMessage: 'Please enter a valid password.',
            forgotYourPassword: 'Need to reset your password?',
            privacyStatement: 'Privacy Statement',
            submit: 'Submit',
            userValidationMessage:
                "We couldn't find an account with this information.",
        },
        RecoveryModal: {
            Title: 'Let’s get your username.',
            bodyText:
                'A new tab will open. Once you are done, come back here to finish your download. ',
            letsGo: "Let's go",
            cancel: 'Cancel',
        },
        RecoveryModalForPasswordReset: {
            Title: 'Let’s get your password.',
            bodyText:
                'A new tab will open. Once you are done, come back here to finish your download.',
            letsGo: "Let's go",
            cancel: 'Cancel',
        },
        PasscodePage: {
            subHeader: 'Enter One-time Passcode',
            bodyText: 'Sent to',
            enterPasscode: 'Enter One-time Passcode',
            validationMessage: 'Please enter a valid passcode.',
            validationMessage1: 'One-time passcode is invalid.',
            didNotGetPasscode: 'Didn’t get your passcode?',
        },
        InvalidPasswordPage: {
            subHeader:
                'Your account has been temporarily locked because you tried to log in too many times. You can try again later or call us at (800) 300-1506 for help.',
        },
        InvalidOTPErrorPage: {
            subHeader:
                'Too many incorrect passcodes were entered. Call us at (800)300-1506 for help.',
        },
        AccountLockPage: {
            subHeader: 'Account Locked',
            bodyText:
                'Your account is locked. Call the Service Center for help. ',
            serviceCenter: 'Covered California Service Center',
            phoneNumber: '(855) 708-4590',
            serviceHours: 'Service Hours',
            extendedHours: 'Extended Hours',
            Exit: 'Exit',
        },
        ServiceUnavailablePage: {
            Title: 'Something went wrong',
            subHeader:
                'Sorry, but we’re not able to complete this request right now. Please try again later.',
        },
        SessionExpiredPage: {
            subHeader:
                'Your session has expired. To start over, click “Exit” below.',
        },
        PasscodeModal: {
            subHeader: 'Didn’t get the passcode?',
            bodyText: 'Call us at (855) 708-4590 ',
            close: 'Close',
        },
        OtpTypePage: {
            subHeader: 'Receive One-time Passcode',
            bodyText:
                'To verify your identity, how would you like to receive your one-time passcode?',
            email: 'To your email',
            phone: 'To your cell phone',
            submit: 'Submit',
            validationMessage: ' You must make a selection to continue.',
            Note: '*Standard text message rates apply.',
            token: ' Use expired token',
            Submit: 'Submit',
        },
        DownloadPage: {
            subHeader: 'Here’s your form.',
            bodyText: 'Click on the link below to download it.',
            bodyText1: 'Download My',
            bodyText2: 'To see your past tax forms',
            bodyText3: 'log in',
            bodyText4: 'and visit your account dashboard.',
            download: 'Download',
            closeButton: 'Close',
            downloadLinkText: 'Download PDF',
            getAnotherTaxForm: 'Get another tax form',
        },
        EncryptionDecryptionErrorPage: {
            Title: 'Something went wrong',
            subHeader:
                'This request can not be completed. Please try again later.',
        },
        ServiceCenterPage: {
            subHeader: 'Verification Method Needed.',
            bodyText:
                'Your email or phone number is not on file to send a one-time passcode. Call the Service Center to update your account.',
            serviceCenter: 'Covered California Service Center',
            phoneNumber: '(855) 708-4590',
            serviceHours: 'Service Hours',
            extendedHours: 'Extended Hours',
            Exit: 'Exit',
        },
        NoTaxformPage: {
            subHeader: 'Tax Forms Unavailable',
            bodyText:
                'There are no tax forms available in your account. Contact the Service Center for more help. ',
            serviceCenter: 'Covered California Service Center',
            phoneNumber: '(855) 708-4590',
            serviceHours: 'Service Hours',
            extendedHours: 'Extended Hours',
            Exit: 'Exit',
        },
        TaxFormPasswordExceededAttemptsPage: {
            subHeader:
                'Too many login attempts. Try again in 30 minutes or call (800) 300-1506 for help.',
        },
        TTaxFormPasscodeExceededAttemptsPage: {
            subHeader:
                'Your account has been temporarily locked because you entered an incorrect one-time passcode too many times. You can try again later or call us at (800) 300-1506 for help.',
        },
        TaxFormSelectionPage: {
            subHeader: 'Select Your Tax Form',
            bodyText: 'Which form would you like to download?',
            inputValidationMessage: 'Please select a tax form to continue.',
        },
        TaxFormPasswordExpiredPage: {
            subHeader:
                'Your password has expired. To update it log in or call us at 800-300-1506.',
        },
        AccountNotFound: {
            subHeader: 'Call us to verify your account.',
            bodyText:
                'Either the user cannot be found, or we have no contact information on file and are unable to verify your identity.  ',
            serviceCenter: 'Covered California Service Center',
            phoneNumber: '(855) 708-4590',
            serviceHours: 'Service Hours',
            extendedHours: 'Extended Hours',
            Exit: 'Exit',
        },
    },
    es: {
        RetunToChatButton: 'Volver al chat',
        Close: 'Cerrar',
        Help: 'Ayuda',
        PhoneSupport: 'Soporte telefónico',
        OffBusinessHours: 'Fuera del horario laboral',
        SHOW_USER_NOT_FOUND:
            'No se pudo encontrar la cuenta. Inténtelo de nuevo o llame al (855) 708-4590 para obtener ayuda.',
        NavButton: {
            BackButton: 'Atrás',
            NextButton: 'Siguiente',
            Confirm: 'Confirmar',
            Close: 'Cerrar',
            Cancel: 'Cancelar',
            ExitButton: 'Salir',
            ProvideFeedbackButton: 'Proporcionar comentarios',
            BeginButton: 'Comenzar',
            StartOverButton: 'Empezar de nuevo',
            SubmitButton: 'Enviar',
        },
        WelcomePage: {
            Title: 'Obtén tu formulario ',
            Body: 'Estás a solo unos pocos pasos de descargar tu formulario de impuestos. ¡Comencemos! ',
            Body1: 'podemos ayudarle a mantener o cancelar su plan. ',
            alt: 'Medi-Cal y Covered California Logos',
        },
        AuthenticationPage: {
            header: 'Verifica tu identidad',
            subHeader: 'Ingresa tu información a continuación.',
            username: 'Nombre de usuario',
            userNamePlaceholder: 'Ingresa el nombre de usuario',
            validationUsernameMessage:
                'Por favor ingresa un nombre de usuario válido.',
            password: 'Contraseña',
            forgotUsername: '¿Olvidaste tu nombre de usuario?',
            passwordPlaceholder: 'Ingresa la contraseña',
            validationPasswordMessage:
                'Por favor ingresa una contraseña válida.',
            forgotYourPassword: 'Restablece tu contraseña',
            privacyStatement: 'Declaración de privacidad',
            submit: 'Enviar',
            userValidationMessage:
                'No se pudo encontrar una cuenta con esta información.',
        },
        TaxFormSelectionPage: {
            subHeader: 'Selecciona tu formulario',
            bodyText: '¿Quál formulario te gustaría descargar?',
            inputValidationMessage:
                'Por favor selecciona un formulario de impuestos para continuar.',
        },
        OtpTypePage: {
            subHeader: 'Recibe un código de acceso de un solo uso',
            bodyText:
                'Para verificar tu identidad, ¿cómo te gustaría recibir tu código de acceso de un solo uso?',
            email: 'Correo electrónico',
            phone: 'Teléfono celular',
            submit: 'Enviar',
            validationMessage: 'Debes realizar una selección para continuar.',
            Note: '*Se aplica la tarifa estándar de mensaje de texto.',
            token: 'Usar token vencido',
            Submit: 'Enviar',
        },
        PasscodePage: {
            subHeader: 'Ingresa el código de acceso de un solo uso',
            bodyText: 'Enviado a',
            enterPasscode: 'Ingresa el código de acceso de un solo uso',
            validationMessage: 'Por favor ingrese un código de acceso válido.',
            validationMessage1:
                'El código de acceso de un solo uso no es válido.',
            didNotGetPasscode: '¿No recibiste tu código de acceso?',
        },
        PasscodeModal: {
            subHeader: '¿No recibiste el código de acceso?',
            bodyText: 'Llámanos al (855) 708-4590',
            close: 'Cerrar',
        },
        DownloadPage: {
            subHeader: 'Aquí está tu formulario',
            bodyText: 'Haz clic en el siguiente enlace para descargarlo.',
            bodyText1: 'Descargar mi ',
            bodyText2: 'Para ver tus formularios de impuestos anteriores',
            bodyText3: 'inicia sesión',
            bodyText4: 'y visita el tablero de tu cuenta.',
            download: 'Descargar',
            closeButton: 'Cerrar',
            downloadLinkText: 'Descargar PDF',
            getAnotherTaxForm: 'Obtener otro formulario',
        },
        EncryptionDecryptionErrorPage: {
            Title: 'Algo salió mal',
            subHeader:
                'No se puede completar esta solicitud. Por favor, inténtalo de nuevo más tarde.',
        },
        SessionExpiredPage: {
            subHeader:
                'Tu sesión expiró. Para comenzar de nuevo, haz clic en "Salir" a continuación.',
        },
        TaxFormPasswordExceededAttemptsPage: {
            subHeader:
                'Demasiados intentos de inicio de sesión. Inténta de nuevo en 20 minutos o llama al (800) 300-1506 para obtener ayuda.',
        },
        NoTaxformPage: {
            subHeader: 'Formularios no disponibles',
            bodyText:
                'No hay formularios de impuestos disponibles en tu cuenta. Comunícate con el Centro de Servicio para obtener más ayuda.',
            serviceCenter: 'Centro de Servicio de Covered California',
            phoneNumber: '(855) 708-4590',
            serviceHours: 'Horario de servicio',
            extendedHours: 'Horario extendido',
            Exit: 'Salir',
        },
        ServiceCenterPage: {
            subHeader: 'Se necesita un método de verificación',
            bodyText:
                'Tu correo electrónico o número de teléfono no están registrados para enviar un código de acceso de un solo uso. Llama al Centro de Servicio para actualizar tu cuenta.',
            serviceCenter: 'Centro de Servicio de Covered California',
            phoneNumber: '(855) 708-4590',
            serviceHours: 'Horario de servicio',
            extendedHours: 'Horario extendido',
            Exit: 'Salir',
        },
        RecoveryModal: {
            Title: 'Nombre de ususario',
            bodyText:
                'Se abrirá una nueva pestaña. Ya que termines, vuelve aquí para terminar la descarga.',
            letsGo: 'Vamos',
            cancel: 'Cancelar',
        },
        RecoveryModalForPasswordReset: {
            Title: 'Obtén tu contraseña',
            bodyText:
                'Se abrirá una nueva pestaña. Ya que termines, vuelve aquí para terminar la descarga.',
            letsGo: 'Vamos',
            cancel: 'Cancelar',
        },
        InvalidPasswordPage: {
            subHeader:
                'Tu cuenta ha sido bloqueada temporalmente porque intentaste iniciar sesión demasiadas veces. Puedes intentarlo de nuevo más tarde o llamarnos al (800) 300-1506 para obtener ayuda.',
        },
        InvalidOTPErrorPage: {
            subHeader:
                'Tu cuenta ha sido bloqueada temporalmente porque ingresaste un código de acceso de un solo uso incorrecto demasiadas veces. Puedes intentarlo de nuevo más tarde o llamarnos al (800) 300-1506 para obtener ayuda.',
        },
        AccountLockPage: {
            subHeader: 'Cuenta bloqueada',
            bodyText:
                'Tu cuenta está bloqueada. Llama al Centro de Servicio para obtener ayuda.',
            serviceCenter: 'Centro de Servicio de Covered California',
            phoneNumber: '(855) 708-4590',
            serviceHours: 'Horario de servicio',
            extendedHours: 'Horario extendido',
            Exit: 'Salir',
        },
        ServiceUnavailablePage: {
            Title: 'Algo salió mal',
            subHeader:
                'Lo siento, pero no podemos completar esta solicitud en este momento. Por favor, inténtalo de nuevo más tarde.',
        },
        TaxFormPasswordExpiredPage: {
            subHeader:
                'Tu contraseña expiró. Para actualizarla, inicia sesión o llámanos al 800-300-1506.',
        },
    },
};
